(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  //Adds class to header items within are focused
  document.addEventListener("DOMContentLoaded", function() {
    const headerWrapper = document.querySelector('.header-wrapper');
    const dropdowns = document.querySelectorAll('details.menu-toggle-selector');

    headerWrapper.addEventListener('focusin', function() {
      headerWrapper.classList.add('menu-open-active');
    });
    headerWrapper.addEventListener('focusout', function() {
      headerWrapper.classList.remove('menu-open-active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technical-diagram"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {

  const hotpoints = document.querySelectorAll(".hotspot-point__exact");

  hotpoints.forEach((hotspot) => {
    const button = hotspot.querySelector(".pin_point");
    const data = button?.getAttribute("data");

    // When a hotspot is clicked
    hotspot.addEventListener("click", function (e) {
    e.stopPropagation(); // Prevent outside click logic

    // Hide all chip cards and remove z-index from sections
    document.querySelectorAll(".hotspot__group.visible").forEach((card) => {
      card.classList.remove("visible");
    });
    document.querySelectorAll("section.hotspot-active").forEach((section) => {
      section.classList.remove("hotspot-active");
    });

    // Show the chip card for this hotspot
    const parentGroup = hotspot.closest(".hotspot__group");
    const chipCard = parentGroup?.querySelector(".hotspot__card .hotspot__card-content");

    if (chipCard) {
      parentGroup.classList.add("visible");
      // Add z-index to parent section
      const parentSection = parentGroup.closest("section");
      if (parentSection) {
        parentSection.classList.add("hotspot-active");
      }
    }

  });

});

// Hide chip cards on outside click or close button click
document.addEventListener("click", function (e) {

  const clickedHotspot = e.target.closest(".hotspot-point__exact");
  const clickedCard = e.target.closest(".hotspot__card");
  const clickedCardCross = e.target.closest(".hotspot__card .svg-wrapper");

  if ((!clickedHotspot && !clickedCard) || clickedCardCross) {
    document.querySelectorAll(".hotspot__group").forEach((card) => {
      card.classList.remove("visible");
    });
    // Remove z-index from sections when hotspots are closed
    document.querySelectorAll("section.hotspot-active").forEach((section) => {
      section.classList.remove("hotspot-active");
    });
  }
});

});


  } catch(e) { console.error(e); }
})();
})();
